import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
export var ExpectedShipDate = function(param) {
    var shipDate = param.shipDate;
    if (!shipDate) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                "data-test-id": "expected-ship-range",
                children: shipDate
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 5
            })
        ]
    });
};
